import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import PlanPopover from './PlanPopover'
import CreditPopover from './CreditPopover'
import RemainingTasks from './RemainingTasks'
import CreditsAndPlansDetailsDrawer from './CreditsAndPlansDetailsDrawer'
import CreditsAndPlansContext from './context'
import { useTranslation } from 'react-i18next'
import { Wallet } from '@mui/icons-material'
import { useGetWalletBalanceQuery } from 'src/_api/mapitShipApi'
import { useGetSubscriptionInfoQuery } from 'src/_api/planApi'
import { useSelector } from 'react-redux'
import { IRONER, ZSHIP_ID } from 'src/constants'

export default function CreditsAndPlansDetails() {
    const { t } = useTranslation();
    const theme = useTheme();
    const downMd = useMediaQuery((theme) => theme.breakpoints.down('md'))

    const { profile } = useSelector((state) => state.entities.profile)

    const isMapitShipOnly = profile?.merchant?.deliveryMethod?.length === 1 && profile?.merchant?.deliveryMethod?.includes("MAPIT_SHIP")

    const { data: credits, isLoading: creditsLoading } = useGetWalletBalanceQuery({})
    const { data: subscriptionInfo, isLoading: subscriptionInfoLoading } = useGetSubscriptionInfoQuery({})

    const [open, setOpen] = useState(false);

    const toggleDrawer =
        (open) =>
            (event) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    ((event).key === 'Tab' ||
                        (event).key === 'Shift')
                ) {
                    return;
                }

                setOpen(open);
            };

    return (
        <CreditsAndPlansContext.Provider
            value={{
                planName: !!subscriptionInfo?.plan ? subscriptionInfo?.plan[theme.direction === "rtl" ? "name_ar" : "name_en"] : t("Free Plan"),
                planNameLoading: subscriptionInfoLoading,
                downMd,
                credits: credits?.balance?.toFixed(2) ?? 0,
                creditsLoading,
                remainingTasks: subscriptionInfo?.remainingTasksCount ?? 0,
                remainingTasksLoading: subscriptionInfoLoading,
                isSubscribeToPlan: subscriptionInfo ?? false,
                isThirdPartyMerchant: !!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id || !!IRONER.includes(profile?.merchant?.id),
                isMapitShipOnly,
            }}>
            {
                downMd ?
                    // <Button 
                    // color='white' 
                    // onClick={toggleDrawer(true)} 
                    // variant='outlined' 
                    // startIcon={<InfoOutlined color='white' />}
                    // sx={{ textTransform: 'none' }}
                    // >
                    //     {t("More details")}
                    // </Button>
                    <IconButton id="toobar-credit-details" onClick={toggleDrawer(true)} >
                        <Wallet color='white' />
                    </IconButton>
                    :
                    <Box display="flex" alignItems='center' gap={2}>
                        {!isMapitShipOnly &&
                            <>
                                <RemainingTasks />
                                <PlanPopover />
                            </>
                        }
                        <CreditPopover />
                    </Box>
            }
            <CreditsAndPlansDetailsDrawer
                open={open}
                toggleDrawer={toggleDrawer}
                isMapitShipOnly={isMapitShipOnly}
            />
        </CreditsAndPlansContext.Provider>
    )
}
